export function isTestEmail(email: string) {
  const emailRegex = /^(lmp|expert)(\+test|\+dev|\+staging)?@primum\.co$/;

  return emailRegex.test(email.toLowerCase());
}
